import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import styled from "styled-components";
import * as _ from "lodash";
import * as Typos from "src/components/atoms/Typographs";
import routes from "src/constants/routes";
import wishService from "src/services/wish.service";
import { Btn, CheckboxWrapper } from "src/theme/Styled";
import { PRICE_POINTS } from "src/constants";
import Images from "src/theme/Images";
import ShareModal from "../ShareModal";
import Modal from "react-responsive-modal";
import { RECEIVED_EX, WISHLIST_EX } from "src/constants/placeholders";
import { disableBodyOverflow, enableBodyOverflow } from "src/utils/functions";

import LOGINACTION from "src/redux/actions";
import { LOGIN_NAVIGATE_BUTTON } from "src/theme/Labels";
import { Submit } from "src/components/atoms/Buttons";

const ListPage = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.users?.user);

  const [items, setItems] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [received, setReceived] = useState([]);
  const [retailers, setRetailers] = useState([]);
  const [selectedPricePoints, selectPricePoints] = useState([]);
  const [selectedRetailers, selectRetailers] = useState([]);
  const [selectedItems, selectItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingReceived, setLoadingReceived] = useState(false);

  const [isSharing, setIsSharing] = useState(false);
  const [shareData, setShareData] = useState([]);
  const [isOpenShareModal, openShareModal] = useState(false);

  const [isLoginModal, setisLoginModal] = useState(false);

  const showLoginModal = () => {
    setisLoginModal(true);
  };

  const openSign = () => {
    setisLoginModal(false);
    dispatch({
      type: LOGINACTION.SIDEBAR.OPEN_SIGN,
    });
  };

  const fetchItems = () => {
    setLoading(true);
    wishService
      .load()
      .then((data) => {
        setLoading(false);
        setItems(data.items);
        setFiltered(data.items);
        const itemRetailers = [];
        data.items.forEach((e) =>
          e.retailer ? itemRetailers.push(e.retailer) : null
        );
        const retailers = _.uniq(itemRetailers);
        setRetailers(retailers);
      })
      .catch((err) => {});
  };

  const fetchReceived = () => {
    setLoadingReceived(true);
    wishService
      .loadReceived()
      .then((data) => {
        setLoadingReceived(false);
        setReceived(data.items);
      })
      .catch((err) => {});
  };

  const togglePricePoint = (point) => {
    const pos = selectedPricePoints.indexOf(point.id);
    if (pos !== -1) {
      selectedPricePoints.splice(pos, 1);
    } else {
      selectedPricePoints.push(point.id);
    }
    selectPricePoints([...selectedPricePoints]);
    filterWishItems(selectedPricePoints, selectedRetailers);
  };
  const toggleRetailer = (retailer) => {
    const pos = selectedRetailers.indexOf(retailer);
    if (pos !== -1) {
      selectedRetailers.splice(pos, 1);
    } else {
      selectedRetailers.push(retailer);
    }
    selectRetailers([...selectedRetailers]);
    filterWishItems(selectedPricePoints, selectedRetailers);
  };

  const generateSearchQuery = (pricePoints, retailers) => {
    let query = { $and: [] };
    if (retailers?.length) {
      query["$and"].push({ retailer: { $in: retailers } });
    }
    if (pricePoints?.length) {
      const prices = [];
      PRICE_POINTS.forEach((e) => {
        if (pricePoints.includes(e.id)) {
          prices.push(e);
        }
      });
      const priceQuery = { $or: [] };
      if (prices.length) {
        prices.forEach((e) => {
          const priceElQuery = { price: {} };
          if (e.low) {
            priceElQuery["price"]["$gt"] = e.low;
          }
          if (e.up) {
            priceElQuery["price"]["$lte"] = e.up;
          }
          priceQuery["$or"].push(priceElQuery);
        });
        query["$and"].push(priceQuery);
      }
    }
    if (!query["$and"]?.length) {
      query = null;
    }
    return query;
  };

  const filterWishItems = (prices, retailers) => {
    const query = generateSearchQuery(prices, retailers);
    selectItems([]);
    if (!query) {
      setFiltered(items);
    } else {
      const filteredItems = items.filter((e) => {
        for (const subQuery of query["$and"]) {
          if (subQuery?.retailer?.$in?.length) {
            if (!subQuery["retailer"]["$in"].includes(e.retailer)) {
              return false;
            }
          }
          if (subQuery["$or"]) {
            for (const priceQuery of subQuery["$or"]) {
              if (priceQuery["price"]) {
                const max = priceQuery["price"]["$lte"] || 10000000000;
                const min = priceQuery["price"]["$gt"] || 0;
                if (e.price > min && e.price < max) {
                  return true;
                }
              }
            }
            return false;
          }
        }
        return true;
      });
      setFiltered([...filteredItems]);
    }
  };

  useEffect(() => {
    if (user) {
      fetchItems();
      fetchReceived();
    }
    setisLoginModal(user ? false : true);
  }, []);

  useEffect(() => {
    if (isOpenShareModal) {
      disableBodyOverflow();
    } else {
      enableBodyOverflow();
    }
  }, [isOpenShareModal]);

  const _renderHeader = () => {
    const pricePoints = PRICE_POINTS || [];

    return (
      <Header
        className={
          "mb-3 d-flex v-center" + (isSharing ? " has-share-controls" : "")
        }
      >
        <FilterOptions className="d-flex dropdowns-wrapper">
          <UncontrolledDropdown className="clear-dropdown">
            <DropdownToggle>
              <Typos.Toggler spacing={0}>PRICE</Typos.Toggler>
            </DropdownToggle>
            <DropdownMenu>
              {pricePoints.map((e, index) => (
                <CheckboxWrapper className="my-1" key={index}>
                  <input
                    type="checkbox"
                    onChange={() => togglePricePoint(e)}
                    defaultChecked={selectedPricePoints.includes(e.id)}
                    id={`wl-price-${e.id}`}
                  />
                  <Typos.FLabel>{e.title}</Typos.FLabel>
                </CheckboxWrapper>
              ))}
            </DropdownMenu>
          </UncontrolledDropdown>

          <UncontrolledDropdown className="ml-3 clear-dropdown">
            <DropdownToggle>
              <Typos.Toggler>RETAILER</Typos.Toggler>
            </DropdownToggle>
            <DropdownMenu>
              {retailers
                .sort((a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1))
                .map((e, index) => (
                  <CheckboxWrapper className="my-1" key={index}>
                    <input
                      type="checkbox"
                      onChange={() => toggleRetailer(e)}
                      defaultChecked={selectedRetailers.includes(e)}
                      id={`wl-retailer-${e}`}
                    />
                    <Typos.FLabel>{e}</Typos.FLabel>
                  </CheckboxWrapper>
                ))}
            </DropdownMenu>
          </UncontrolledDropdown>
        </FilterOptions>
        <div
          className={
            "ml-auto d-flex v-center" + (isSharing ? " share-controls" : "")
          }
        >
          {isSharing ? (
            <>
              <Btn
                theme="outline"
                className="mx-1 fit-width d-flex align-items-center"
                onClick={selectAll}
              >
                Select All
              </Btn>
              <Btn
                theme="outline"
                className="mx-1 fit-width d-flex align-items-center"
                onClick={cancelSelection}
              >
                Cancel
              </Btn>
              <Btn
                className="mx-1 fit-width d-flex align-items-center"
                onClick={shareSelection}
              >
                Share
              </Btn>
            </>
          ) : (
            <Btn
              theme="no-border"
              className="ml-auto fit-width d-flex align-items-center"
              onClick={() => setIsSharing(true)}
            >
              <img src={Images.shareIcon} className="d-block" />
              <Typos.H9 className="ml-1">Share</Typos.H9>
            </Btn>
          )}
        </div>
      </Header>
    );
  };

  const selectAll = () => {
    const ids = filtered.map((e) => e._id);
    selectItems(ids);
  };

  const cancelSelection = () => {
    selectItems([]);
    setIsSharing(false);
  };

  const shareSelection = () => {
    const selectedWishes = items.filter((e) => selectedItems.includes(e._id));
    setShareData(selectedWishes);
    openShareModal(true);
  };

  const _renderItemCell = (item, index) => {
    return (
      <Item
        key={index}
        as={isSharing ? "div" : Link}
        to={routes.WISH_LIST + "/" + item._id}        
        style={{maxWidth:"156px"}}
      >
        <div className={"image-wrapper" + (isSharing ? " prompting" : "")}>
          <img
            src={item.thumbnail ? item.thumbnail : Images.GiftIcon}
            alt="wish-item"
          />
          {isSharing ? (
            <CheckboxWrapper className="checkbox">
              <input
                type="checkbox"
                onChange={() => toggleItem(item)}
                checked={selectedItems.includes(item._id)}
                id={`wl-s-${item._id}`}
              />
              <Typos.FLabel htmlFor={`wl-s-${item._id}`}></Typos.FLabel>
            </CheckboxWrapper>
          ) : null}
          {item.favorite ? (
            <img src={Images.HeartIcon} className="favorite-mark" />
          ) : null}
        </div>
        <Typos.H6 className="text-center" lines={2}>
          {item.name}
        </Typos.H6>
        <Typos.H7 className="text-center">
          {item.price ? "$" + item.price : ""}
        </Typos.H7>
      </Item>
    );
  };

  const _renderPlaceholderWish = (item, index) => {
    return (
      <Item key={index} className="placeholder-item">
        <div className={"image-wrapper"}>
          <img src={item.file} alt="wish-item" />
        </div>
        <Typos.H6 className="text-center fake-text" lines={2}>
          {item.item_name}
        </Typos.H6>
        <Typos.H7 className="text-center fake-text">
          {item.price ? "$" + item.price : ""}
        </Typos.H7>
      </Item>
    );
  };

  const _renderPlaceholderReceive = (item, index) => {
    return (
      <Item key={index} className="placeholder-item">
        <div className={"image-wrapper"}>
          <img src={item.file} alt="wish-item" />
        </div>
      </Item>
    );
  };

  const toggleItem = (item) => {
    const pos = selectedItems.indexOf(item._id);
    if (pos !== -1) {
      selectedItems.splice(pos, 1);
    } else {
      selectedItems.push(item._id);
    }
    selectItems([...selectedItems]);
  };

  const _renderReceivedItem = (item, index) => {
    return (
      <Item key={index} as={Link} to={routes.WISH_LIST + "/" + item._id}>
        <div className="image-wrapper">
          <img
            src={item.thumbnail ? item.thumbnail : Images.GiftIcon}
            alt="wish-item"
          />
        </div>
      </Item>
    );
  };

  return (
    <>
      <Typos.PageTitle className="text-center mb-0">Wish List</Typos.PageTitle>
      <Typos.PageGuide>
        Add to your wish list from any store using{" "}
        <a
          href="https://blog.thegiftguide.com/sign-up-install-add-to-the-gift-guide-button/"
          className="td-underline"
        >
          The Gift Guide Button and App
        </a>
        . Include details like size and color. Looking for ideas? Check out our{" "}
        <Link to={routes.GIFTGUIDES} className="td-underline">
          Gift Guides
        </Link>
        .
      </Typos.PageGuide>
      <div>
        {_renderHeader()}
        <List className="mt-2">
          {user ? (
            <PlusItem as={Link} to={routes.ADD_WISH_ITEM} style={{maxWidth:"156px"}}>
              <div className="area">
                <div>
                  <span>+</span>
                </div>
              </div>
              <Typos.H6 className="text-center" lines={2}>
                ADD TO WISH LIST
              </Typos.H6>
            </PlusItem>
          ) : (
            <PlusItem onClick={showLoginModal} style={{maxWidth:"156px"}}>
              <div className="area">
                <div>
                  <span>+</span>
                </div>
              </div>
              <Typos.H6 className="text-center" lines={2}>
                ADD TO WISH LIST
              </Typos.H6>
            </PlusItem>
          )}

          {items.length ? (
            <>
              {(filtered || []).map((item, i) => (
                <React.Fragment key={i}>
                  {_renderItemCell(item, i)}
                </React.Fragment>
              ))}
            </>
          ) : (
            WISHLIST_EX.map((item, i) => (
              <React.Fragment key={i}>
                {_renderPlaceholderWish(item, i)}
              </React.Fragment>
            ))
          )}
        </List>
      </div>
      <div>
        <Typos.H4B className="section-title">RECEIVED ITEMS</Typos.H4B>
        <div>
          <ReceivedList>
            {received.length ? (
              <>
                {(received || []).map((item, i) => (
                  <React.Fragment key={i}>
                    {_renderReceivedItem(item, i)}
                  </React.Fragment>
                ))}
              </>
            ) : (
              <>
                {RECEIVED_EX.map((item, i) => (
                  <React.Fragment key={i}>
                    {_renderPlaceholderReceive(item, i)}
                  </React.Fragment>
                ))}
              </>
            )}
          </ReceivedList>
          <div className="desc-overlay">
            <Typos.Desc>
              Mark items from your wish list as “received” once you have
              received items to move them off your wish list. For step-by-step
              instructions, refer to the{" "}
              <Link
                to={routes.GIFTGUIDES}
                className="text-decoration-underline"
              >
                Start Guide.
              </Link>
            </Typos.Desc>
          </div>
        </div>
      </div>

      <Modal
        open={isOpenShareModal}
        onClose={() => openShareModal(false)}
        blockScroll={false}
        classNames={{
          root: "shareModalroot",
        }}
      >
        <ShareModal
          data={shareData}
          type="wish-item"
          onClose={() => openShareModal(false)}
        />
      </Modal>

      <Modal
        open={isLoginModal}
        blockScroll={false}
        onClose={() => setisLoginModal(false)}
        classNames={{
          root: "loginModalroot",
          modal: "loginModal",
        }}
      >
        <Typos.PageTitle className="login_title">
          Oops, you need to login for that
        </Typos.PageTitle>
        <div className="login_description">
          In order to use that feature, you need to log in or create an account.
        </div>
        <div className="login_btn">
          <Submit
            type="button"
            title={LOGIN_NAVIGATE_BUTTON}
            onClick={openSign}
          />
        </div>
      </Modal>
    </>
  );
};

const List = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 18px;

  @media screen and (max-width: 960px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media screen and (max-width: 780px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (max-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
const ReceivedList = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 8px;

  @media screen and (max-width: 960px) {
    grid-template-columns: repeat(5, 1fr);
  }
  @media screen and (max-width: 780px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media screen and (max-width: 500px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
const PlusItem = styled.div`
  .area {
    width: 100%;
    height: 0px;
    padding-top: 100%;
    position: relative;
    background-color: black;

    div {
      display: flex;
      position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
    }
  }
  span {
    margin: auto;
    padding-left: 10px;
    padding-right: 10px;
    font-family: Assistant, sans-serif;
    font-weight: 200;
    font-size: 90px;
    cursor: pointer;
    color: white;
  }
`;
const Header = styled.div`
  .share-controls {
    button {
      min-width: 100px;
      justify-content: center;
    }
  }
  .dropdowns-wrapper {
    height: 40px;
    align-items: center;
  }

  @media screen and (max-width: 530px) {
    &.has-share-controls {
      display: block !important;
    }
    .share-controls {
      display: grid !important;
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 6px;

      button {
        margin: 0px !important;
        min-width: unset;
        font-size: 14px;
      }
    }
  }
`;
const FilterOptions = styled.div`
  .dropdown-menu.show > div {
    align-items: flex-start;
    white-space: nowrap;

    label {
      height: unset;
    }
  }
`;
const Item = styled.div`
  .image-wrapper {
    width: 100%;
    height: 0px;
    padding-top: 100%;
    position: relative;

    img {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .checkbox {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      background-color: rgba(220, 220, 220, 0.46);

      label {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;

        &::before {
          background-color: white;
          left: 8px;
          top: 8px;
          transform: none;
        }

        &::after {
          left: 8px;
          top: 8px;
          transform: none;
        }
      }
    }

    .favorite-mark {
      top: 8px;
      right: 8px;
      width: 24px;
      height: 24px;
      left: unset;
    }
  }
`;

export default ListPage;
